import { useEffect } from 'react';
import TopNav from '../components/TopNav';
import { useApp } from '../AppContext';

const S = {
  // Banners
  successBanner: { background: 'linear-gradient(135deg,#0A7A4A 0%,#0DB36B 100%)', borderRadius: 16, padding: '28px 32px', marginBottom: 24, display: 'flex', alignItems: 'center', gap: 20, position: 'relative', overflow: 'hidden' },
  failedBanner: { background: 'linear-gradient(135deg,#9B1C1C 0%,#E53E3E 100%)', borderRadius: 16, padding: '28px 32px', marginBottom: 24, display: 'flex', alignItems: 'center', gap: 20, position: 'relative', overflow: 'hidden' },
  icoWrap: (color) => ({ width: 56, height: 56, borderRadius: '50%', background: 'rgba(255,255,255,.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 26, flexShrink: 0 }),
  bannerTitle: { fontSize: 20, fontWeight: 800, color: '#fff', marginBottom: 3 },
  bannerSub: { fontSize: 12.5, color: 'rgba(255,255,255,.75)' },
  bannerTxn: { fontSize: 11, color: 'rgba(255,255,255,.5)', marginTop: 5, fontFamily: 'monospace', letterSpacing: '.5px' },
  bannerBadge: { marginLeft: 'auto', flexShrink: 0, textAlign: 'right' },
  bannerAmt: { fontSize: 30, fontWeight: 800, color: '#fff', lineHeight: 1 },
  bannerAmtLbl: { fontSize: 10.5, color: 'rgba(255,255,255,.6)', marginTop: 3, textAlign: 'right' },

  // Wallet card
  walletCard: { background: 'linear-gradient(135deg,var(--nv) 0%,#252B4A 100%)', borderRadius: 12, padding: '20px 24px', marginBottom: 16, display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 14 },
  wbi: { textAlign: 'center' },
  wbl: { fontSize: 9.5, fontWeight: 700, color: 'rgba(255,255,255,.45)', textTransform: 'uppercase', letterSpacing: '.6px', marginBottom: 5 },
  wbv: { fontSize: 22, fontWeight: 800, color: '#fff', lineHeight: 1.1 },

  // Receipt card
  card: { background: 'var(--wh)', borderRadius: 12, border: '1px solid var(--g200)', boxShadow: '0 4px 16px rgba(26,31,54,.10)', overflow: 'hidden', marginBottom: 16 },
  rhead: { padding: '18px 24px 14px', borderBottom: '1px solid var(--g100)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  rtitle: { fontSize: 13.5, fontWeight: 700, color: 'var(--nv)' },
  rsub: { fontSize: 11, color: 'var(--g400)', marginTop: 2 },

  // Info grid
  igrid: { display: 'grid', gridTemplateColumns: '1fr 1fr' },
  iitemBase: { padding: '14px 24px', borderBottom: '1px solid var(--g100)' },
  ikey: { fontSize: 10, fontWeight: 700, color: 'var(--g400)', textTransform: 'uppercase', letterSpacing: '.5px', marginBottom: 4 },
  ival: { fontSize: 13, fontWeight: 600, color: 'var(--nv)' },
  ivalMono: { fontSize: 11.5, fontWeight: 600, fontFamily: 'monospace', color: 'var(--g600)' },

  // Amount box
  amtSectionLbl: { fontSize: 10, fontWeight: 700, color: 'var(--g400)', textTransform: 'uppercase', letterSpacing: '.6px', marginBottom: 2, padding: '14px 24px 0', borderTop: '1px solid var(--g100)' },
  amtbox: { padding: '0 24px 20px' },
  amtrow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '9px 0', borderBottom: '1px solid var(--g100)' },
  amtrowLast: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '9px 0' },
  aml: { fontSize: 12.5, color: 'var(--g600)' },
  amv: { fontSize: 13, fontWeight: 600, color: 'var(--nv)' },

  // Total footer
  successTotal: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 24px', background: 'var(--nv)', borderRadius: '0 0 12px 12px' },
  failedTotal: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 24px', background: 'linear-gradient(135deg,#9B1C1C,#E53E3E)', borderRadius: '0 0 12px 12px' },
  totalLbl: { fontSize: 13.5, fontWeight: 700, color: 'rgba(255,255,255,.75)' },
  totalVal: { fontSize: 20, fontWeight: 800 },

  // Chips
  chipGreen: { display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 9px', borderRadius: 50, fontSize: 10.5, fontWeight: 600, background: '#E6FAF3', color: '#0A7A4A' },
  chipRed: { display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 9px', borderRadius: 50, fontSize: 10.5, fontWeight: 600, background: '#FEF0F0', color: '#C53030' },

  // Reason box
  reasonBox: { background: '#FEF0F0', border: '1.5px solid rgba(229,62,62,.35)', borderRadius: 8, padding: '14px 18px', marginBottom: 16, display: 'flex', alignItems: 'flex-start', gap: 12 },
  reasonTitle: { fontSize: 13, fontWeight: 700, color: '#C53030', marginBottom: 3 },
  reasonDesc: { fontSize: 12, color: 'var(--g800)', lineHeight: 1.6 },
  reasonCode: { display: 'inline-block', marginTop: 6, padding: '2px 8px', background: 'rgba(229,62,62,.12)', borderRadius: 4, fontSize: 10.5, fontFamily: 'monospace', color: '#C53030', fontWeight: 600 },

  // Wallet safe
  walletSafe: { background: '#E6FAF3', border: '1.5px solid rgba(13,179,107,.3)', borderRadius: 8, padding: '14px 18px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 12 },

  // Invoice note
  invNote: { background: '#EFF6FF', border: '1px solid rgba(59,130,246,.25)', borderRadius: 8, padding: '12px 16px', display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 24 },

  // What next card
  nextCard: { background: 'var(--wh)', borderRadius: 12, border: '1px solid var(--g200)', padding: '18px 22px', marginBottom: 16 },
  stepNum: { width: 24, height: 24, borderRadius: '50%', background: '#FFF3DC', border: '1.5px solid rgba(245,166,35,.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10.5, fontWeight: 800, color: '#D4880A', flexShrink: 0, marginTop: 1 },

  // Support note
  supportNote: { background: '#FFFBEB', border: '1px solid rgba(245,158,11,.3)', borderRadius: 8, padding: '12px 16px', display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 24 },

  // Actions
  actions: { display: 'flex', gap: 10, justifyContent: 'center', marginBottom: 24, flexWrap: 'wrap' },
  footer: { textAlign: 'center', fontSize: 10.5, color: 'var(--g400)', paddingBottom: 24, lineHeight: 1.7 },
};

function fmt(n) {
  return `₹${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function IItem({ label, value, mono, style }) {
  return (
    <div style={{ ...S.iitemBase, ...(style || {}) }}>
      <div style={S.ikey}>{label}</div>
      <div style={mono ? S.ivalMono : S.ival}>{value}</div>
    </div>
  );
}

function AmtRow({ label, value, last, muted }) {
  return (
    <div style={last ? S.amtrowLast : S.amtrow}>
      <span style={S.aml}>{label}</span>
      <span style={{ ...S.amv, ...(muted ? { color: 'var(--g400)' } : {}) }}>{value}</span>
    </div>
  );
}

export default function PaymentReceipt({ onNavigate, isSuccess, result, error, amounts, clientInfo, currentBalance }) {
  const { setWalletBalance } = useApp();
  const { topup_amount, cgst_amount, sgst_amount, igst_amount, payable_amount } = amounts || {};
  const isGujNonSez = cgst_amount > 0 || sgst_amount > 0;

  useEffect(() => {
    if (isSuccess && result?.new_balance != null) {
      setWalletBalance(parseFloat(result.new_balance) || 0);
    }
  }, []);

  function copyTxnId() {
    const id = result?.transaction_id || error?.razorpay_payment_id || '';
    if (id) navigator.clipboard?.writeText(id);
  }

  if (isSuccess) {
    return (
      <>
        <TopNav currentPage="wallet" onNavigate={onNavigate} />
        <div className="pg" style={{ maxWidth: 800, margin: '0 auto' }}>

          {/* Success Banner */}
          <div style={S.successBanner}>
            <div style={S.icoWrap()}>✓</div>
            <div>
              <div style={S.bannerTitle}>Payment Successful!</div>
              <div style={S.bannerSub}>Your wallet has been credited successfully.</div>
              <div style={S.bannerTxn}>
                TXN: {result.transaction_id} &nbsp;·&nbsp; Razorpay: {result.razorpay_payment_id}
              </div>
            </div>
            <div style={S.bannerBadge}>
              <div style={S.bannerAmt}>{fmt(result.payable_amount)}</div>
              <div style={S.bannerAmtLbl}>Total Amount Paid</div>
            </div>
          </div>

          {/* Wallet Balance Summary */}
          <div style={S.walletCard}>
            <div style={S.wbi}>
              <div style={S.wbl}>Previous Balance</div>
              <div style={S.wbv}>{fmt(result.previous_balance)}</div>
            </div>
            <div style={{ ...S.wbi, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
              <div style={{ fontSize: 10, fontWeight: 700, color: 'rgba(255,255,255,.35)', textTransform: 'uppercase', letterSpacing: '.6px' }}>Wallet Credited</div>
              <div style={{ fontSize: 28, fontWeight: 800, color: 'var(--or)' }}>+{fmt(result.wallet_credit)}</div>
            </div>
            <div style={S.wbi}>
              <div style={S.wbl}>New Balance</div>
              <div style={{ ...S.wbv, color: 'var(--or)' }}>{fmt(result.new_balance)}</div>
            </div>
          </div>

          {/* Receipt Card */}
          <div style={S.card}>
            <div style={S.rhead}>
              <div>
                <div style={S.rtitle}>🧾 Payment Receipt</div>
                <div style={S.rsub}>Invoice No: {result.invoice_number} &nbsp;·&nbsp; Date: {result.invoice_date}</div>
              </div>
              <span style={S.chipGreen}>● Payment Verified</span>
            </div>

            <div style={S.igrid}>
              <IItem label="Transaction ID" value={result.transaction_id} mono style={{ borderRight: '1px solid var(--g100)' }} />
              <IItem label="Razorpay Payment ID" value={result.razorpay_payment_id} mono />
              <IItem label="Invoice Number" value={result.invoice_number} style={{ borderRight: '1px solid var(--g100)' }} />
              <IItem label="Invoice Date" value={result.invoice_date} />
              <IItem label="Payment Method" value="Razorpay Gateway" style={{ borderRight: '1px solid var(--g100)', borderBottom: 'none' }} />
              <IItem label="Payment Status" value="✓ Verified & Credited" style={{ color: 'var(--gr)', borderBottom: 'none' }} />
            </div>

            <div style={S.amtSectionLbl}>Amount Breakdown</div>
            <div style={S.amtbox}>
              <AmtRow label="Top-up Amount (Wallet Credit)" value={fmt(result.topup_amount ?? topup_amount)} />
              {isGujNonSez ? (
                <>
                  <AmtRow label="CGST @ 9%" value={fmt(result.cgst_amount ?? cgst_amount)} />
                  <AmtRow label="SGST @ 9%" value={fmt(result.sgst_amount ?? sgst_amount)} />
                  <AmtRow label="IGST" value="₹0.00" muted />
                </>
              ) : (
                <>
                  <AmtRow label="CGST" value="₹0.00" muted />
                  <AmtRow label="SGST" value="₹0.00" muted />
                  <AmtRow label="IGST @ 18%" value={fmt(result.igst_amount ?? igst_amount)} />
                </>
              )}
            </div>
            <div style={S.successTotal}>
              <span style={S.totalLbl}>Total Payable Amount</span>
              <span style={{ ...S.totalVal, color: 'var(--or)' }}>{fmt(result.payable_amount ?? payable_amount)}</span>
            </div>
          </div>

          {/* Invoice Note */}
          <div style={S.invNote}>
            <span style={{ fontSize: 15, flexShrink: 0, marginTop: 1 }}>ℹ️</span>
            <div style={{ fontSize: 11.5, color: 'var(--g800)', lineHeight: 1.6 }}>
              <strong style={{ color: 'var(--nv)' }}>GST Invoice Ready</strong> — Your tax invoice <strong style={{ color: 'var(--nv)' }}>{result.invoice_number}</strong> has been generated. You can download it from the{' '}
              <span onClick={() => onNavigate('invoices')} style={{ color: '#3B82F6', fontWeight: 600, cursor: 'pointer' }}>GST Invoices</span> section. This receipt is for reference only and does not replace the official GST invoice.
            </div>
          </div>

          {/* Actions */}
          <div style={S.actions}>
            {/* <button className="btn bout" onClick={() => window.print()}>🖨️ Print Receipt</button>
            <button className="btn bout" onClick={() => onNavigate('invoices')}>📄 View GST Invoice</button> */}
            <button className="btn bpri" onClick={() => onNavigate('dashboard')}>→ Go to Dashboard</button>
          </div>

          <div style={S.footer}>
            System-generated payment receipt for <strong>cFIRST India Prepaid BGV Portal</strong>.<br />
            For support, contact <a href="mailto:support@cfirst.in" style={{ color: 'var(--or-dk)', fontWeight: 600 }}>support@cfirst.in</a>
          </div>
        </div>
      </>
    );
  }

  // ── Failure ──────────────────────────────────────────────
  const errDescription = error?.description || error?.message || 'Transaction could not be completed.';
  const errReason = error?.reason || '';
  const errCode = error?.code || '';
  const rzpPaymentId = error?.razorpay_payment_id || error?.metadata?.payment_id || '—';

  return (
    <>
      <TopNav currentPage="wallet" onNavigate={onNavigate} />
      <div className="pg" style={{ maxWidth: 800, margin: '0 auto' }}>

        {/* Failed Banner */}
        <div style={S.failedBanner}>
          <div style={S.icoWrap()}>✗</div>
          <div>
            <div style={S.bannerTitle}>Payment Failed</div>
            <div style={S.bannerSub}>Your transaction could not be completed. No amount was debited.</div>
            {rzpPaymentId !== '—' && (
              <div style={S.bannerTxn}>Razorpay: {rzpPaymentId}</div>
            )}
          </div>
          <div style={S.bannerBadge}>
            <div style={S.bannerAmt}>{fmt(payable_amount)}</div>
            <div style={S.bannerAmtLbl}>Attempted Amount</div>
          </div>
        </div>

        {/* Failure Reason */}
        <div style={S.reasonBox}>
          <div style={{ fontSize: 20, flexShrink: 0 }}>🚫</div>
          <div>
            <div style={S.reasonTitle}>Failure Reason: {errDescription}</div>
            <div style={S.reasonDesc}>
              Your bank or payment provider declined this transaction. This could be due to insufficient funds, daily transaction limit exceeded, or a security block. Please check with your bank or try a different payment method.
            </div>
            {(errCode || errReason) && (
              <span style={S.reasonCode}>
                {[errCode, errReason].filter(Boolean).join(' · ')}
              </span>
            )}
          </div>
        </div>

        {/* Wallet Safe */}
        <div style={S.walletSafe}>
          <div style={{ fontSize: 22, flexShrink: 0 }}>🔒</div>
          <div>
            <div style={{ fontSize: 12.5, fontWeight: 700, color: '#0A7A4A', marginBottom: 2 }}>Your Wallet Balance is Safe</div>
            <div style={{ fontSize: 11.5, color: 'var(--g800)' }}>No amount was deducted. Your wallet balance remains unchanged.</div>
          </div>
          <div style={{ marginLeft: 'auto', textAlign: 'right', flexShrink: 0 }}>
            <div style={{ fontSize: 9.5, fontWeight: 700, color: 'var(--g400)', textTransform: 'uppercase', letterSpacing: '.5px' }}>Current Balance</div>
            <div style={{ fontSize: 18, fontWeight: 800, color: '#0DB36B' }}>{fmt(currentBalance)}</div>
          </div>
        </div>

        {/* Transaction Details */}
        <div style={S.card}>
          <div style={S.rhead}>
            <div>
              <div style={S.rtitle}>🧾 Transaction Details</div>
              <div style={S.rsub}>Attempted payment — not charged</div>
            </div>
            <span style={S.chipRed}>● Failed</span>
          </div>

          <div style={S.igrid}>
            <IItem label="Razorpay Payment ID" value={rzpPaymentId} mono style={{ borderRight: '1px solid var(--g100)' }} />
            <IItem label="Payment Method" value="Razorpay Gateway" />
            <IItem label="Transaction Status" value="✗ Payment Failed" style={{ borderRight: '1px solid var(--g100)', color: '#C53030' }} />
            <IItem label="Wallet Credited" value="No — Not Credited" style={{ color: '#C53030' }} />
            <IItem label="Amount Debited" value="₹0.00 — Not Charged" style={{ borderRight: '1px solid var(--g100)', borderBottom: 'none', color: '#0A7A4A' }} />
            <IItem label="Refund Status" value="N/A — Amount Not Debited" style={{ borderBottom: 'none', color: '#0A7A4A' }} />
          </div>

          <div style={S.amtSectionLbl}>Attempted Amount Breakdown</div>
          <div style={S.amtbox}>
            <AmtRow label="Top-up Amount (Wallet Credit)" value={fmt(topup_amount)} />
            {isGujNonSez ? (
              <>
                <AmtRow label="CGST @ 9%" value={fmt(cgst_amount)} />
                <AmtRow label="SGST @ 9%" value={fmt(sgst_amount)} />
                <AmtRow label="IGST" value="₹0.00" muted />
              </>
            ) : (
              <>
                <AmtRow label="CGST" value="₹0.00" muted />
                <AmtRow label="SGST" value="₹0.00" muted />
                <AmtRow label="IGST @ 18%" value={fmt(igst_amount)} />
              </>
            )}
          </div>
          <div style={S.failedTotal}>
            <span style={S.totalLbl}>Attempted Total (Not Charged)</span>
            <span style={{ ...S.totalVal, color: '#fff' }}>{fmt(payable_amount)}</span>
          </div>
        </div>

        {/* What to do next */}
        <div style={S.nextCard}>
          <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--nv)', marginBottom: 14, paddingBottom: 10, borderBottom: '1px solid var(--g100)' }}>💡 What to do next?</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {[
              ['Check your bank account', 'Verify that no amount was debited. If debited, it will be auto-refunded within 5–7 business days.'],
              ['Try a different payment method', 'Use a different card, UPI ID, or net banking account to complete your top-up.'],
              ['Check transaction limits', 'Ensure your daily UPI/card limit is not exceeded and your bank has not blocked online transactions.'],
              ['Contact support', 'If the issue persists, reach out to our team for quick resolution.'],
            ].map(([title, desc], i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                <div style={S.stepNum}>{i + 1}</div>
                <div style={{ fontSize: 12, color: 'var(--g800)', lineHeight: 1.6 }}>
                  <strong style={{ color: 'var(--nv)' }}>{title}</strong> — {desc}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Support Note */}
        <div style={S.supportNote}>
          <span style={{ fontSize: 15, flexShrink: 0, marginTop: 1 }}>⚠️</span>
          <div style={{ fontSize: 11.5, color: 'var(--g800)', lineHeight: 1.6 }}>
            <strong style={{ color: 'var(--nv)' }}>Need Help?</strong> — If you believe this is an error or notice any unexpected deduction, contact us at{' '}
            <a href="mailto:support@cfirst.in" style={{ color: 'var(--or-dk)', fontWeight: 600 }}>support@cfirst.in</a>.
            Our team typically responds within 2 business hours.
          </div>
        </div>

        {/* Actions */}
        <div style={S.actions}>
          <button className="btn bout" onClick={() => window.print()}>🖨️ Print Details</button>
          <button className="btn bout" onClick={copyTxnId}>📋 Copy Payment ID</button>
          <button className="btn bout" onClick={() => window.location.href = 'mailto:support@cfirst.in'}>💬 Contact Support</button>
          <button className="btn bpri" onClick={() => onNavigate('wallet')}>↩ Retry Payment</button>
        </div>

        <div style={S.footer}>
          System-generated failed transaction record for <strong>cFIRST India Prepaid BGV Portal</strong>.<br />
          For support, contact <a href="mailto:support@cfirst.in" style={{ color: 'var(--or-dk)', fontWeight: 600 }}>support@cfirst.in</a>
        </div>
      </div>
    </>
  );
}
